import * as React from 'react';

import { Outlet } from 'react-router-dom';
const HeaderContent = () => {
	return <Outlet />;
};

export default HeaderContent;
